<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import MubinApiServices from "../../../services/MubinApi";

export default {
  data() {
    return {
      input_code: "",
      submit: false,
      loadingButton: false,

      errorInCode: false,
      selectedForm: "",
    };
  },
  validations: {
    input_code: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {},
  methods: {
    // Window scroll method
    windowScroll() {
      const navbar = document.getElementById("navbar");
      const title = document.getElementById("color-title");
      if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
        navbar.classList.add("nav-sticky");
        title.classList.add("font-color-black");
      } else {
        navbar.classList.remove("nav-sticky");
        title.classList.remove("font-color-black");
      }
    },
    // Toggle menu
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },

    // validation form submit
    id_code() {
      this.submit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$error) return;
      this.onComplete();
    },
    onComplete: function () {
      this.errorInCode = false;
      this.loadingButton = true;

      MubinApiServices.checkcode(this.input_code)
        .then((response) => {
          if (response.data.category != "مستفيد") {
            throw new Error("code : 500");
          }

          if (response.status == 200) {
            if (this.selectedForm == "scholar-ships") {
              window.location.replace(
                "https://scholar-ships.emtenan.org/beneficiary/" + this.input_code
              );
            } else if (this.selectedForm == "housing-units") {
              window.location.replace(
                "https://housing-units.emtenan.org/housing-units/martyrs/" +
                  this.input_code
              );
            } else if (this.selectedForm == "housing-loans") {
              window.location.replace(
                "https://housing-loans.emtenan.org/housing-loans/martyrs/" +
                  this.input_code
              );
            } else {
              this.$router.push({
                name: this.selectedForm,
                params: { code: this.input_code },
              });
            }
          } else {
            throw new Error("Not Found code");
          }
        })
        .catch(() => {
          this.errorInCode = true;
          this.loadingButton = false;
        });
    },
    sendForm(formName) {
      this.resetModel();
      this.selectedForm = formName;
    },
    resetModel() {
      this.submit = false;
      this.selectedForm = "";
      this.errorInCode = false;
      this.input_code = "";
    },
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
      <div class="container">
        <a class="navbar-logo" href="javascript: void(0);">
          <img src="@/assets/images/logo1.svg" alt height="50" class="logo logo-dark" />
          <img src="@/assets/images/logo2.svg" alt height="50" class="logo logo-light" />
        </a>
        <!-- <h4 class="mx-2 my-0 color-title" id="color-title">منصة امتنان</h4> -->

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          data-toggle="collapse"
          data-target="#topnav-menu-content"
          @click="toggleMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul
            class="navbar-nav ms-auto"
            id="topnav-menu"
            v-scroll-spy-active="{ selector: 'a.nav-link' }"
          >
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#home'" href="javascript: void(0);"
                >الرئيسية</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#features'" href="javascript: void(0);"
                >الخدمات</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#about-us'" href="javascript: void(0);"
                >من نحن</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div v-scroll-spy>
      <div class="header" id="home">
        <div class="container d-grid main-header-content">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="text-white">
                <h1 class="text-white mb-3 main-title">منصة امتنان</h1>
                <p class="secondary-title">
                  مجموعة خدمات مقدمة الى جميع فئات الحشد الشعبي .
                </p>
                <a
                  href="javascript: void(0);"
                  class="btn btn-home"
                  v-scroll-to="'#features'"
                  >انتقل للخدمات</a
                >
              </div>
            </div>
            <div class="col-md-12 col-lg-6"></div>
            <div class="box-image">
              <img class="img-home" src="@/assets/images/home/home.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 100"
        preserveAspectRatio="none"
        class="pattern-bg"
      >
        <path
          class="elementor-shape-fill"
          opacity="0.33"
          d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
        ></path>
        <path
          class="elementor-shape-fill"
          opacity="0.66"
          d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
        ></path>
        <path
          class="elementor-shape-fill"
          d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
        ></path>
      </svg>

      <!-- Features start -->
      <section class="section mt-5" id="features">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center mb-5">
                <h5><div class="small-title">خدمات المنصة</div></h5>
                <h4>استفد من الخدمات المقدمة من قبل المنصة</h4>
              </div>
            </div>
          </div>
          <!-- end row -->

          <b-modal
            id="modal-input-code"
            centered
            hide-footer
            title="هوية امتنان"
            title-class="font-18"
            no-close-on-backdrop
          >
            <form action="#" @submit.prevent="id_code">
              <b-form-group
                class="col-md-12 text-center"
                label=" ادخل رمز هوية امتنان الخاص بك "
                label-for="input_code"
              >
                <b-form-input
                  id="input_code"
                  type="number"
                  placeholder="ادخل الرمز"
                  v-model="input_code"
                  class="text-center"
                  :class="{ 'is-invalid': submit && $v.input_code.$error }"
                ></b-form-input>
                <div v-if="submit && $v.input_code.$error" class="invalid-feedback">
                  <span v-if="!$v.input_code.required">يجب ادخال الرمز</span>
                  <span v-if="!$v.input_code.minLength"
                    >يجب أن يتكون الرمز من 10 ارقام</span
                  >
                  <span v-if="!$v.input_code.maxLength"
                    >يجب أن يتكون الرمز من 10 ارقام</span
                  >
                </div>
                <div v-if="errorInCode" class="">
                  <span>هذا الرمز غير موجود</span>
                </div>
              </b-form-group>
              <b-button
                type="submit"
                class="mt-3 bg-color-blue"
                style="width: 100%"
                :disabled="loadingButton"
              >
                <span class="" v-if="!loadingButton">انتقل للاستمارة</span>
                <b-spinner v-else small label="انتظر..."></b-spinner>
              </b-button>
            </form>
          </b-modal>

          <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-2 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-0">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">01</div>
                  <h4 class="mb-0">استمارة الوحدات السكنية</h4>
                </div>
                <p class="text-muted">استمارة خاصة بالتقديم على الوحدات السكنية .</p>
                <!-- <p class="text-muted">
                  استمارة خاصة بالتقديم على الوحدات السكنية ومن ضمنها مجمع بسماية السكني .
                </p> -->
                <!-- <div class="mt-1 me-2 d-inline-block">
                  <a
                    class="btn btn-outline-blue w-xs"
                    v-b-modal.modal-input-code
                    @click="sendForm('housing-units')"
                    >فئة الشهداء</a
                  >
                </div> -->
                <!-- <div class="mt-1 me-2 d-inline-block">
                  <a
                    href="https://housing-units.emtenan.org/housing-units/woundeds"
                    class="btn btn-outline-blue w-xs"
                    >فئة الجرحى</a
                  >
                </div>
                <div class="mt-1 d-inline-block">
                  <a
                    href="https://housing-units.emtenan.org/housing-units/employees"
                    class="btn btn-outline-blue w-xs"
                    >فئة المنتسبين</a
                  >
                </div> -->
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-1">
              <div class="mt-4 me-md-0">
                <img
                  src="@/assets/images/home/img-4.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-1 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-auto">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">02</div>
                  <h4 class="mb-0">استمارة الحج</h4>
                  <!-- <p style="padding-top: 22px; font-size: 15px; margin-right: 10px">
                    ( الاستمارة مغلقة )
                  </p> -->
                </div>
                <p class="text-muted">
                  الاستمارة مخصصة للتقديم على اداء فريضة الحج للجرحى وعوائل الشهداء يتم
                  التقديم من خلال مكاتب المحافظات حصرا .
                </p>
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-2">
              <div>
                <img
                  src="@/assets/images/home/img-3.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-2 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-0">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">03</div>
                  <h4 class="mb-0">استمارة قروض الاسكان</h4>
                </div>
                <p class="text-muted">استمارة خاصة بالتقديم على قروض الاسكان .</p>
                <div class="mt-1 me-2 d-inline-block">
                  <a
                    class="btn btn-outline-blue w-xs"
                    v-b-modal.modal-input-code
                    @click="sendForm('housing-loans')"
                    >فئة الشهداء</a
                  >
                </div>
                <div class="mt-1 me-2 d-inline-block">
                  <a
                    href="https://housing-loans.emtenan.org/housing-loans/woundeds"
                    class="btn btn-outline-blue w-xs"
                    >فئة الجرحى</a
                  >
                </div>
                <div class="mt-1 d-inline-block">
                  <a
                    href="https://housing-loans.emtenan.org/housing-loans/employees"
                    class="btn btn-outline-blue w-xs"
                    >فئة المنتسبين</a
                  >
                </div>
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-1">
              <div class="mt-4 me-md-0">
                <img
                  src="@/assets/images/home/img-6.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-1 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-auto">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">04</div>
                  <h4 class="mb-0">استمارة المنح الدراسية</h4>
                </div>
                <p class="text-muted">
                  الاستمارة مخصصة لتقديم المنح الدراسية في الجمهورية الاسلامية الايرانية .
                </p>
                <div class="mt-1 me-2 d-inline-block">
                  <a
                    class="btn btn-outline-blue w-xs me-2"
                    v-b-modal.modal-input-code
                    @click="sendForm('scholar-ships')"
                    >فئة الشهداء</a
                  >
                  <a
                    href="https://scholar-ships.emtenan.org/"
                    class="btn btn-outline-blue w-xs"
                    >بقية الفئات</a
                  >
                </div>
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-2">
              <img
                src="@/assets/images/home/img-5.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
          </div>
          <!-- end row -->

          <!-- <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-2 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-auto">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">05</div>
                  <h4 class="mb-0">استمارة اطفاء القروض الحكومية</h4>
                </div>
                <p class="text-muted">
                  الاستمارة مخصصة لاطفاء القروض الحكومية التي بذمة الشهداء والجرحى .
                </p>
                <div class="mt-1 me-2 d-inline-block">
                  <a
                    class="btn btn-outline-blue w-xs"
                    v-b-modal.modal-input-code
                    @click="sendForm('bank-loans.martyr')"
                    >فئة الشهداء</a
                  >
                </div>
                <div class="mt-1 d-inline-block">
                  <a href="/bank-loans/injured" class="btn btn-outline-blue w-xs"
                    >فئة الجرحى</a
                  >
                </div>
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-1">
              <img
                src="@/assets/images/home/img-1.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
          </div> -->
          <!-- end row -->

          <!-- <div class="row align-items-center mt-3">
            <div class="col-md-7 col-sm-12 order-md-1 mb-3 text-center text-md-start">
              <div class="mt-4 mt-md-0">
                <div class="d-md-flex d-inline-flex align-items-center mb-2">
                  <div class="font-color-red display-4 me-3">06</div>
                  <h4 class="mb-0">استمارة قطع الاراضي والبدل النقدي</h4>
                </div>
                <p class="text-muted">
                  استمارة خاصة بالشهداء والجرحى للتقديم على قطع الاراضي والبدل النقدي .
                </p>
                <div class="mt-1 me-2 d-inline-block">
                  <a
                    class="btn btn-outline-blue w-xs"
                    v-b-modal.modal-input-code
                    @click="sendForm('plots-of-land.martyr')"
                    >فئة الشهداء</a
                  >
                </div>
                <div class="mt-1 d-inline-block">
                  <a href="/plots-of-land/injured" class="btn btn-outline-blue w-xs"
                    >فئة الجرحى</a
                  >
                </div>
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-2">
              <div class="mt-4 me-md-0">
                <img
                  src="@/assets/images/home/img-2.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
            </div>
          </div> -->
          <!-- end row -->
        </div>
        <!-- end container -->
      </section>
      <!-- Features end -->

      <!-- about us -->
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
          class="pattern-bg pattern-about"
        >
          <path
            class="elementor-shape-fill"
            opacity="0.33"
            d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
          ></path>
          <path
            class="elementor-shape-fill"
            opacity="0.66"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
            class="elementor-shape-fill"
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>
      </div>
      <div class="mt-3 about-us" id="about-us">
        <div class="container">
          <div class="row align-items-center">
            <div
              class="col-md-7 col-sm-12 order-md-2 mb-3 mt-5 text-center text-md-start"
            >
              <h5>من نحن</h5>
              <div>
                <p class="mt-4">
                  امتنان هي منصة الكترونية مهمتها توظيف التكنولوجيا لخدمة الجمهور بأبسط
                  واسرع الطرق وتأمين وصول الخدمات والاستجابة بأسرع وقت ممكن لتقديم خدمات
                  صحية وثقافية واجتماعية وتعليمية توفرها مديريات مختلفة مرتبطة او تابعة
                  للحشد الشعبي لعوائل الشهداء والجرحى وعوائلهم ومنتسبي الهيئة وجمهور الحشد
                  الشعبي .
                </p>
                <!-- <div class="social-icons">
                  <a href="#"><i class="fab fa-instagram"></i></a>
                  <a href="#"><i class="fab fa-facebook"></i></a>
                </div> -->
              </div>
            </div>
            <div class="col-md-5 col-sm-12 order-md-1 mt-2 mt-md-5">
              <img
                src="@/assets/images/home/about.png"
                alt
                class="img-fluid mx-auto d-block img-about"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Footer start -->
      <footer class="landing-footer">
        <div class="container">
          <div class="row mt-5">
            <div class="col-md-4 mb-4">
              <div class="fast-link-footer">
                <h5 class="mx-0 text-white">للتواصل</h5>
                <div class="p-about text-white mt-3">
                  <p>للتواصل معنا الاتصال على الرقم : 07864969222</p>
                </div>
                <!-- <div class="social-icons">
                  <a class="text-white font-size-22" href="#"
                    ><i class="fab fa-instagram"></i
                  ></a>
                  <a class="text-white font-size-22 mx-2" href="#"
                    ><i class="fab fa-facebook"></i
                  ></a>
                </div> -->
              </div>
            </div>
            <div class="col-md-4">
              <div class="">
                <h5 class="mx-0 text-white">روابط ذات صلة</h5>
                <ul class="menu-footer">
                  <li>
                    <div class="icon-callus">
                      <i><img src="@/assets/images/home/elaqat.png" alt height="30" /></i>
                    </div>
                    <div class="call-us">
                      <a v-scroll-to="'#'" href="javascript: void(0);">
                        المديرية العامة للعلاقات والخدمات الاجتماعية</a
                      >
                    </div>
                  </li>

                  <li>
                    <div class="icon-callus">
                      <i><img src="@/assets/images/home/vwc.png" alt height="30" /></i>
                    </div>
                    <div class="call-us">
                      <a v-scroll-to="'#'" href="javascript: void(0);"
                        >مركز العمل التطوعي</a
                      >
                    </div>
                  </li>
                  <li>
                    <div class="icon-callus">
                      <i><img src="@/assets/images/home/m3raaj.png" alt height="30" /></i>
                    </div>
                    <div class="call-us">
                      <a v-scroll-to="'#'" href="javascript: void(0);">برنامج معراج</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4 d-none d-md-block">
              <h5 class="mx-0 text-white">منصة امتنان</h5>
              <img src="@/assets/images/logo.png" alt height="100" />
              <div class="p-about mt-3">
                <p>لبعض فضلكم</p>
              </div>
            </div>
          </div>
          <div class="row copy-right">
            <div class="col-md-6">
              <img src="@/assets/images//home/elaqat.png" alt height="25" />
              <span class="mx-2">المديرية العامة للعلاقات والخدمات الاجتماعية</span>
            </div>
            <div class="col-md-6">
              <p class="mt-1 text-md-end d-sm-block">
                {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
              </p>
            </div>
          </div>
        </div>
      </footer>
      <!-- Footer end -->
    </div>
  </div>
</template>
